import React, {Component} from 'react';

export default class Goods extends Component{
    render(){

        return (
            <div>{this.props.children}</div>
        )
    }
}
